import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import _ from "lodash";
import { getItalianStoriesData } from "../index";
import { ItalianStoriesResponseTo } from "../../../models/italianStory";

const useItalianStoriesData = (page: number, step = 3) => {
    const { data } = useQuery({
        queryKey: ["italian-stories-data"],
        queryFn: () => getItalianStoriesData(),
    });
    const [storiesData, setStoriesData] = useState<ItalianStoriesResponseTo[]>(
        []
    );
    const [isFetching, setIsFetching] = useState(false);
    const [hasMoreItem, setHasMoreItem] = useState(true);

    useEffect(() => {
        if (data) {
            setIsFetching(true);
            setHasMoreItem(page * step < data.length);
            // Ordina i dati in base a updated_at in ordine decrescente
            const sortedData = _.orderBy(data, ["createdAt"], ["desc"]);
            setTimeout(() => {
                setStoriesData(
                    sortedData.slice(0, Math.min(data.length, page * step))
                );
                setIsFetching(false);
            }, 2000);
        }
    }, [page, data, step]);

    return {
        storiesData,
        isFetching,
        hasMoreItem,
    };
};

export default useItalianStoriesData;
